import { Routes } from '@angular/router';
import { JobsComponent } from './jobs/jobs.component';
import { VisualVehicleReceptionReportComponent } from './visual-vehicle-reception-report/visual-vehicle-reception-report.component';
import { VhcHome } from './vhc/vhc-home/vhc-home';
import { VhcReport } from './vhc/vhc-report/vhc-report';
import { ShortUrlComponent } from './short-url/short-url.component';
import { ProformaInvoiceServiceOrderComponent } from './proforma-invoice-service-order/proforma-invoice-service-order.component';
import { VhcJobsComponent } from './vhc-jobs/vhc-jobs-home/vhc-jobs/vhc-jobs.component';
import { VvrJobsComponent } from './vvr-jobs/vvr-jobs-home/vvr-jobs/vvr-jobs.component';
import { VhcJobsAuthComponent } from './vhc-jobs/vhc-jobs-auth/vhc-jobs-auth/vhc-jobs-auth.component';
import { VvrJobsAuthComponent } from './vvr-jobs/vvr-jobs-auth/vvr-jobs-auth/vvr-jobs-auth.component';
import { ServiceQuoteHomeComponent } from './service-quotes/service-quote-home/service-quote-home/service-quote-home.component';
import { ServiceOrderHomeComponent } from './service-order/service-order-home/service-order-home/service-order-home.component';
import { ServiceOrderAuthComponent } from './service-order/service-order-auth/service-order-auth/service-order-auth.component';
import { featureFlagGuard } from './guards/feature-flag-guard';
import { ProformaInvoiceHomeComponent } from './proforma-invoice/proforma-invoice-home/proforma-invoice-home.component';
import { ProformaInvoiceAuthComponent } from './proforma-invoice/proforma-invoice-auth/proforma-invoice-auth.component';
import { ServiceQuoteAuthComponent } from './service-quotes/service-quote-auth/service-quote-auth/service-quote-auth.component';
import { SchedulingOrderHomeComponent } from './scheduling-order/scheduling-order-home/scheduling-order-home/scheduling-order-home.component';
import { SchedulingOrderAuthComponent } from './scheduling-order/scheduling-order-auth/scheduling-order-auth/scheduling-order-auth.component';


export const routes: Routes = [
  { path:'',component:ServiceOrderHomeComponent},
  { path: 'jobs', component: JobsComponent },
  { path: 'vvr-report', component: VisualVehicleReceptionReportComponent},
  { path: 'vhc-report', component: VhcHome},
  { path: 'vhc-report/report', component: VhcReport},
  { path: 'proforma-invoice', component: ProformaInvoiceHomeComponent},
  { path: 'proforma-invoice-auth', component: ProformaInvoiceAuthComponent},
  {path: 'vhc-jobs',component:VhcJobsComponent},
  {path: 'vvr-jobs',component:VvrJobsComponent},
  {path:'vhc-jobs-auth', component:VhcJobsAuthComponent},
  {path:'vvr-jobs-auth' , component:VvrJobsAuthComponent},
  {path:'service-quote' , component:ServiceQuoteHomeComponent},
  {path:'service-quote-auth' , component:ServiceQuoteAuthComponent},
  {path:'scheduling-order' , component:SchedulingOrderHomeComponent},
  {path:'scheduling-order-auth' , component:SchedulingOrderAuthComponent},
  {path:'service-order-auth',component:ServiceOrderAuthComponent},
  {path: ':id', component: ShortUrlComponent },
];